import * as Sentry from "@sentry/react";
import { Routes, Route } from "react-router-dom";

import { routes } from "./routes";
import ProtectedPage from "PrivateRoutes";
import Secondpage from "pages/Login/Login";
import UnauthorizedPage from "./Unauthorized";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

const RouteFallback = () => (
  <div className="flex flex-col items-center justify-center h-[60vh] gap-4">
    <h2 className="text-xl font-semibold">Page error</h2>
    <p className="text-gray-600">This page encountered an error.</p>
    <button
      className="px-4 py-2 bg-primary-button text-white rounded-md"
      onClick={() => window.location.reload()}
    >
      Refresh page
    </button>
  </div>
);

const Router = () => (
  // <Sentry.ErrorBoundary fallback={<RouteFallback />} onError={(err) => console.error('[ErrorBoundary]', err)}>
  <Sentry.ErrorBoundary fallback={<RouteFallback />}>
    <SentryRoutes>
      <Route path="/login" element={<Secondpage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {routes.map((x) => (
        <Route
          key={x.name}
          path={x.path}
          element={
            <ProtectedPage requiredPermission={x.requiredPermission}>
              {x.element}
            </ProtectedPage>
          }
        />
      ))}
    </SentryRoutes>
  </Sentry.ErrorBoundary >
);

export default Router;
